import { Box } from "@mui/system";
import { Divider, Typography, Skeleton } from "@mui/material";
import { Colors } from "../../helpers/Consts";

export type ShoppingBagSkelletonProps = {
  placeInfo: any;
  toggleDrawer: () => void;
};

function ShoppingBagSkeleton({placeInfo, toggleDrawer, }:ShoppingBagSkelletonProps) {

  return (
    <Box p={2} minWidth={"360px"}>
      <Box padding="20px">
        <Typography
          color={Colors.baseTextColor}
          style={{ fontWeight: 300 }}
        >
          Seu pedido em
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" style={{ fontWeight: 700 }}>
            {placeInfo?.name}
          </Typography>
          <Box sx={{ flexGrow: 1 }} />
          {/* <Box
                    component={Link}
                    to={`/delivery?place_id=${placeInfo?.id}&table=${
                      table ? table : 1
                    }`}
                    sx={{
                      textDecoration: "none",
                    }}
                  > */}
          <Typography
            color="primary"
            onClick={toggleDrawer}
            sx={{ cursor: "pointer" }}
          >
            Ver Cardápio
          </Typography>
          {/* </Box> */}
        </Box>
        <Typography
          fontSize="14px"
          style={{
            fontWeight: 700,
            marginTop: "10px",
          }}
        >
          Categoria
        </Typography>
        <Divider />
        <Skeleton
          variant="rectangular"
          animation="wave"
          sx={{
            borderRadius: "7px",
            width: "100%",
            paddingTop: "20px",
            height: { xs: "180px", sm: "180px", md: "180px" },
          }}
        />

        <Divider />
        <Box
          sx={{
            display: "flex",
            padding: "20px 0px 5px 0px",
          }}
        >
          {/* <Typography fontSize="16px" color={Colors.baseTextColor}>
                  Você está pedindo na mesa
                </Typography> */}
          {/* <Box sx={{ flexGrow: 1 }} /> */}
          <Skeleton
            variant="text"
            sx={{ width: "100%", height: "50px" }}
            animation="wave"
          />
        </Box>
        <Box
          sx={{
            padding: "20px 0px 5px 0px",
          }}
        >
          {/* <Typography fontSize="16px" color={Colors.baseTextColor}>
                  Você está pedindo na mesa
                </Typography> */}
          {/* <Box sx={{ flexGrow: 1 }} /> */}
          <Skeleton
            variant="text"
            sx={{ width: "100%", height: "50px" }}
            animation="wave"
          />
          <Skeleton
            variant="rectangular"
            animation="wave"
            sx={{
              borderRadius: "7px",
              width: "100%",
              paddingTop: "20px",
              height: { xs: "180px", sm: "180px", md: "180px" },
            }}
          />
        </Box>
      </Box>
      <Box p={3} sx={{ marginTop: { md: "auto", sm: "-40px" } }}>
        <Box sx={{ display: "flex" }}>
          <Skeleton
            variant="text"
            sx={{ width: "100%", height: "50px" }}
            animation="wave"
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            marginTop: 1,
          }}
        >
          <Skeleton
            variant="text"
            sx={{ width: "100%", height: "50px" }}
            animation="wave"
          />
        </Box>
        <Box sx={{ marginTop: "10px" }}>
          <Skeleton
            variant="text"
            sx={{ width: "100%", height: "50px" }}
            animation="wave"
          />
        </Box>

        <Skeleton
          variant="text"
          sx={{ width: "100%", height: "50px" }}
          animation="wave"
        />
      </Box>
    </Box>
  );
}
export default ShoppingBagSkeleton;